import React from 'react';
import { ShieldCheck, X } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { BACKEND_URL } from '../lib/api';
import { cn } from '../lib/utils';

const SIZES = { sm: { box: 'h-8 w-8', icon: 'h-4 w-4', logo: 'h-7 max-w-[96px]', text: 'text-[15px]' }, md: { box: 'h-9 w-9', icon: 'h-5 w-5', logo: 'h-8 max-w-[120px]', text: 'text-lg' } };

export function BrandMark({ size = 'sm', subtitle, className, showName = true }) {
  const app = useApp();
  const s = SIZES[size];
  const logo = app?.brand?.logoUrl ? `${BACKEND_URL}${app.brand.logoUrl}` : null;
  return (
    <div className={cn('flex items-center gap-2.5 min-w-0', className)} data-testid="brand-mark">
      <div className={cn('rounded-lg bg-ink-700 text-white flex items-center justify-center shrink-0', s.box)}><ShieldCheck className={s.icon} /></div>
      {showName && <div className="leading-tight min-w-0"><div className={cn('font-semibold text-ink-800 tracking-tight', s.text)}>Evidencer</div>{subtitle && <div className="text-[11px] text-ink-400">{subtitle}</div>}</div>}
      {logo && <><X className="h-3.5 w-3.5 text-ink-300 shrink-0" data-testid="brand-x" /><img src={logo} alt={app.brand.company || 'Company logo'} data-testid="brand-logo" className={cn('w-auto object-contain shrink-0', s.logo)} /></>}
    </div>
  );
}
